import React from "react";
import LetterHeader from "../../components/LetterHeader";
import removeCommas from "../../common/removeCommas";
import { formatIsoDate } from "../../common/formatIsoDate";
import { numberToWords } from "../../common/numberToWords";

const ContractTemplate = ({ data }) => {
  const {
    location,
    checkListOne,
    checkListTwo,
    contractId,
    organization,
    agreementDate,
    poRequestLocation,
    contractStartDate,
    contractEndDate,
    clientName,
    clientDesignation,
    contractorName,
    contractorDesignation,
    organizationName,
    working_days_in_a_week,
    working_hours_in_a_week,
    monthly_payment_cost,
    invoice_text,
    client,
    start,
    end,
  } = data || {};

  return (
    <div
      style={{
        padding: "0.5cm",
        backgroundColor: "#ffffff",
        fontFamily: "serif",
        lineHeight: 1.6,
      }}
    >
      {/* Page 1 */}
      <div>
        <LetterHeader />
      </div>
      <div>
        <h2
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "28px" }}
        >
          Cleaning Contract Agreement
        </h2>
        <div
          style={{
            height: "3px",
            width: "100%",
            backgroundColor: "black",
            margin: "10px 0px",
          }}
        ></div>

        <ol
          type="i"
          style={{
            listStylePosition: "outside",
            textAlign: "justify",
          }}
        >
          <div
            style={{
              position: "relative",
              height: "80vh",
            }}
          >
            <div
              style={{
                position: "absolute",
                bottom: 3,
                right: 3,
                width: 100,
                height: 50,
              }}
            >
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    width: 50,
                    height: 30,
                    border: "1px solid black",
                  }}
                ></div>
                <div
                  style={{
                    width: 50,
                    height: 30,
                    border: "1px solid black",
                  }}
                ></div>
              </div>
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    width: 50,
                    height: 20,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Cont
                </div>
                <div
                  style={{
                    width: 50,
                    height: 20,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Cli
                </div>
              </div>
            </div>
            <li
              style={{
                fontSize: 24,
                lineHeight: 1.5,
              }}
            >
              This janitorial cleaning services agreement (the
              &#34;Agreement&#34;) is dated as of{" "}
              <strong>{formatIsoDate(agreementDate) || "__________"}</strong>,
              by and between{" "}
              <strong>A2Z Professional Cleaning & Maintenance Inc</strong>. With
              a mailing address of 100 Concilum Road, Suite 200, On, M1H 3E3 in
              City of Toronto, State of Ontario (&#34;Contractor&#34;) <br />
              AND
              <br />
              <strong>
                {organizationName || "__________"}
                {organization?.careOf ? "," : ""}
                {organization?.careOf || ""}
              </strong>
              with a mailing address of{" "}
              <strong>{organization?.billingAddress || "__________"}</strong>{" "}
              (&#34;Client&#34;).
              <br />
              (Collectively the &#34;Parties&#34;)
            </li>
            <br />
            <li style={{ fontSize: 24, lineHeight: 1.5, fontFamily: "serif" }}>
              The term of this Agreement shall{" "}
              <strong>
                commence on {formatIsoDate(contractStartDate) || "__________"}{" "}
                to {formatIsoDate(contractEndDate) || "__________"}
              </strong>{" "}
              and can be{" "}
              <strong>
                terminate at-will with written notification of at least 30
                days&#39; notice
              </strong>{" "}
              during the agreement period.
            </li>
            <br />
            <li style={{ fontSize: 24, lineHeight: 1.5, fontFamily: "serif" }}>
              Cleaning location(s):
            </li>
            <ul
              style={{
                fontSize: 24,
                lineHeight: 1.5,
                marginLeft: "20px",
                fontFamily: "serif",
                listStyleType: "disc",
                fontWeight: "bold",
              }}
            >
              {location?.map((loc, idx) => (
                <li key={idx}>{loc.title || loc}</li>
              ))}
            </ul>
            <br />
            <li style={{ fontSize: 24, lineHeight: 1.5, fontFamily: "serif" }}>
              The total cost for the services described herein, not including
              additional services described in Schedule A, shall be: $
              {Number(removeCommas(monthly_payment_cost)) * 3} excluding tax
              (Please see attached Schedule “A”) to be made payable in twelve
              (12) equal monthly payments of $
              {monthly_payment_cost || "__________"} excluding tax (Please see
              attached Schedule &#34;A&#34;) upon receipt of invoice from the
              Contractor, the first of such payments being due at the end of
              each consecutive month commencing on January 1st, 2026 provided
              that all Work has been performed to the satisfaction of the
              Customer and provided that the Contractor has adhered to all terms
              and conditions of this Agreement.
            </li>
            <br />
            <li style={{ fontSize: 24, lineHeight: 1.5, fontFamily: "serif" }}>
              Cleaning:
            </li>
            <ul
              style={{
                fontSize: 24,
                lineHeight: 1.5,
                marginLeft: "20px",
                fontFamily: "serif",
                listStyleType: "disc",
              }}
            >
              {checkListTwo?.map((obj, idx) => (
                <li key={idx}>{obj.name}</li>
              ))}
            </ul>
          </div>

          {/* Page 2 */}
          <div
            style={{
              position: "relative",
              height: "100vh",
            }}
          >
            <div
              style={{
                position: "absolute",
                bottom: 3,
                right: 3,
                width: 100,
                height: 50,
              }}
            >
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    width: 50,
                    height: 30,
                    border: "1px solid black",
                  }}
                ></div>
                <div
                  style={{
                    width: 50,
                    height: 30,
                    border: "1px solid black",
                  }}
                ></div>
              </div>
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    width: 50,
                    height: 20,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Cont
                </div>
                <div
                  style={{
                    width: 50,
                    height: 20,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Cli
                </div>
              </div>
            </div>
            <li
              style={{
                fontSize: 24,
                lineHeight: 1.5,
                fontFamily: "serif",
                pageBreakBefore: "always",
                paddingTop: "1cm",
              }}
            >
              GENERAL PROVISIONS:
            </li>
            <ol
              type="a"
              style={{
                fontSize: 24,
                lineHeight: 1.5,
                marginLeft: "20px",
                fontFamily: "serif",
              }}
            >
              <li>
                The contractor agrees to hold and maintain all necessary
                permits, licenses, etc., and acknowledges that all work shall
                conform to all local codes and applicable government (municipal,
                provincial and federal) Acts by law and regulations, The
                contractor further agrees and acknowledges that all their staff
                has been trained and has knowledge of the Ontario health and
                safety regulations, WHMIS regulations and any other applicable
                Acts, by law and regulations that come into effect during the
                term of the contract. All equipment and personal safety devices
                required shall be provided by the Contractor for their
                employees.
              </li>{" "}
              <br />
              <li>
                It is understood and agreed that the contractor&#39;s employees
                shall be suitably bonded (including, but not limited to
                fidelity, employee dishonesty, etc.) and that the contractor is
                insured for public liability and property damage and shall
                include the corporation as named insured for public liability
                and property damage and shall include the corporation as named
                insured for the contractor&#39;s policy. The contractor further
                agrees to provide the manager with a true copy of said policy
                coverage at the time of acceptance of this contract, including
                the following information.
              </li>{" "}
              <br />
              <li>
                It is further understood and agreed that the contractor and its
                employees are covered under the workplace safety and insurance
                act, and that the contractor will provide a certificate of good
                standing at regular intervals of ninety 90 days. (WSIB No:
                4500638).
              </li>{" "}
              <br />
              <li>
                In the event client shall fail to pay any periodic or
                installment payment due hereunder, Contractor may cease work
                without breach pending payment or resolution of dispute.
              </li>{" "}
              <br />
              <li>
                Contractor shall not be liable for any delay due to circumstance
                beyond its control.
              </li>{" "}
              <br />
              <li>
                Contractor is an independent contractor and not an employee of
                Client.
              </li>
              <br />
              <li>
                Any changes to this document must be signed by both Contractor
                and Owner.
              </li>
            </ol>
          </div>
        </ol>
      </div>

      {/* Page 3 */}

      <div
        style={{
          position: "relative",
          height: "100vh",
          fontSize: 20,
          pageBreakBefore: "always",
          paddingTop: "1cm",
        }}
      >
        <div
          style={{
            position: "absolute",
            bottom: 3,
            right: 3,
            width: 100,
            height: 50,
          }}
        >
          <div style={{ display: "flex" }}>
            <div
              style={{
                width: 50,
                height: 30,
                border: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: 50,
                height: 30,
                border: "1px solid black",
              }}
            ></div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                width: 50,
                height: 20,
                display: "flex",
                justifyContent: "center",
              }}
            >
              Cont
            </div>
            <div
              style={{
                width: 50,
                height: 20,
                display: "flex",
                justifyContent: "center",
              }}
            >
              Cli
            </div>
          </div>
        </div>
        <p>
          IN WITNESS WHEREOF the Parties have executed this Agreement on the
          date first written above.
        </p>
        <br />
        <p style={{ fontWeight: "bold", color: "red" }}>
          A2Z Professional Cleaning & Maintenance
        </p>
        <br />
        <table>
          <tbody>
            <tr>
              <td rowSpan={4} style={{ verticalAlign: "text-top", width: 80 }}>
                per :
              </td>
              <td style={{ borderBottom: "1px solid black", width: 500 }}></td>
            </tr>
            <tr style={{ textAlign: "center", fontWeight: "bold" }}>
              <td>Authorized Signing Officer</td>
            </tr>
            <tr>
              <td>Name: {contractorName}</td>
            </tr>
            <tr>
              <td>Title: {contractorDesignation}</td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td>Date : </td>
              <td style={{ borderBottom: "1px solid black" }}>
                {formatIsoDate(agreementDate)}
              </td>
            </tr>
          </tbody>
        </table>
        <br /> <br />
        <p style={{ fontWeight: "bold", color: "red" }}>Client</p>
        <br />
        <table>
          <tbody>
            <tr>
              <td rowSpan={4} style={{ verticalAlign: "text-top", width: 80 }}>
                per :
              </td>
              <td style={{ borderBottom: "1px solid black", width: 500 }}></td>
            </tr>
            <tr style={{ textAlign: "center", fontWeight: "bold" }}>
              <td>Authorized Signing Officer</td>
            </tr>
            <tr>
              <td>Name: {clientName}</td>
            </tr>
            <tr>
              <td>Title: {clientDesignation}</td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td>Date : </td>
              <td style={{ borderBottom: "1px solid black" }}></td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Page 4 */}
      <div
        style={{
          position: "relative",
          height: "98vh",
          fontSize: 20,
          pageBreakBefore: "always",
          paddingTop: "1cm",
        }}
      >
        <div
          style={{
            position: "absolute",
            bottom: 3,
            right: 3,
            width: 100,
            height: 50,
          }}
        >
          <div style={{ display: "flex" }}>
            <div
              style={{
                width: 50,
                height: 30,
                border: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: 50,
                height: 30,
                border: "1px solid black",
              }}
            ></div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                width: 50,
                height: 20,
                display: "flex",
                justifyContent: "center",
              }}
            >
              Cont
            </div>
            <div
              style={{
                width: 50,
                height: 20,
                display: "flex",
                justifyContent: "center",
              }}
            >
              Cli
            </div>
          </div>
        </div>
        <h1
          style={{
            fontWeight: "bold",
            fontSize: 32,
            textDecoration: "underline",
            textTransform: "uppercase",
            textUnderlineOffset: 5,
          }}
        >
          Schedule A
        </h1>
        <p style={{ fontSize: 20 }}>
          The cleaner will provide cleaning services{" "}
          {numberToWords(working_days_in_a_week)} ({working_days_in_a_week})
          days per week for an average of{" "}
          {working_hours_in_a_week / working_days_in_a_week} hours per day,
          equivalent to {working_hours_in_a_week} hours per week.
        </p>
        <ol
          type="A"
          style={{ fontSize: 20, lineHeight: 1.5, marginLeft: "20px" }}
        >
          {checkListOne?.map((obj, idx) => (
            <>
              <li key={idx}>
                {obj.name} ({obj.value})
              </li>
              <br />
            </>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default ContractTemplate;
